import React, { useRef } from "react"
import { Card } from "../../components/card"
import { ConversationBubble } from "../../components/conversation-bubble"
import { CardFooter } from "../../components/card-footer"
import { InlineWidget } from "react-calendly"
import { decodeFormData } from "../../modules/functions"

import "./style.scss"

const App = () => {
    const bobRef = useRef() as React.MutableRefObject<HTMLDivElement>

    const formData = decodeFormData(window.location.search)

    return (
        <div id="bob" data-testid="bob" ref={bobRef}>
            <Card>
                <ConversationBubble
                    header="Meet your dedicated email expert."
                    para="We'll set everything up and show you how to maximize results for your business."
                />
                <InlineWidget
                    styles={{ width: "auto", height: "600px" }}
                    pageSettings={{ hideEventTypeDetails: true, hideGdprBanner: true, primaryColor: "FF3465" }}
                    prefill={{
                        name: formData.name,
                        email: formData.email,
                        customAnswers: {
                            a1: formData.orgname,
                        },
                    }}
                    url="https://calendly.com/bpm-onboarding-team/last-step-book-your-black-pearl-setup"
                />
                <CardFooter className="bob-next" currentCount={3} maxCount={3} />
            </Card>
        </div>
    )
}

export default App
